/* eslint-disable no-promise-executor-return */
import axios from 'axios';
import wrapAxios from 'zipkin-instrumentation-axios';
import Cookies from 'js-cookie';

import { createTracer } from '../../instrumentation/zipkin-recorder';

const zipkinAxios = () => wrapAxios(axios, {
  tracer: createTracer(),
  serviceName: window.serviceName || 'login-app',
  remoteServiceName: 'login-app'
});
const getAxios = () => (window.zipkinServerUrl ? zipkinAxios() : axios);

const types = {
  LOGIN: 'LOGIN',
  LOGIN_FULFILLED: 'LOGIN_FULFILLED',
  LOGIN_REJECTED: 'LOGIN_REJECTED',
  CLEAR_LOGIN_STATUS: 'CLEAR_LOGIN_STATUS',
  USER_PRIVILEGES: 'USER_PRIVILEGES',
  USER_PRIVILEGES_FULFILLED: 'USER_PRIVILEGES_FULFILLED',
  USER_PRIVILEGES_REJECTED: 'USER_PRIVILEGES_REJECTED',
  GET_EXTERNAL_SIGNIN_PARAMS: 'GET_EXTERNAL_SIGNIN_PARAMS',
  GET_EXTERNAL_SIGNIN_PARAMS_FULFILLED: 'GET_EXTERNAL_SIGNIN_PARAMS_FULFILLED',
  GET_EXTERNAL_SIGNIN_PARAMS_REJECTED: 'GET_EXTERNAL_SIGNIN_PARAMS_REJECTED',
  CLOCK_IN: 'CLOCK_IN',
  CLOCK_IN_FULFILLED: 'CLOCK_IN_FULFILLED',
  CLOCK_IN_REJECTED: 'CLOCK_IN_REJECTED'
};

function doPostLogin(code, protocol, hostname) {
  const data = { code, protocol, hostname };
  const redierctURL = Cookies.get('redierctURL');
  return () => getAxios().post('/signin', data)
  .then((response) => {
    if (redierctURL) {
      Cookies.set('redierctURL', redierctURL);
    }
    return response.data;
  })
  // eslint-disable-next-line prefer-promise-reject-errors
  .catch((error) => new Promise((res, rej) => rej({ error })));
}

function postLogin(code, protocol, hostname) {
  const plAction = {
    type: 'API',
    types: [types.LOGIN, types.LOGIN_FULFILLED, types.LOGIN_REJECTED],
    api: doPostLogin(code, protocol, hostname),
    login: { userName: '' },
  };
  return plAction;
}

function clearLoginStatus() {
  return {
    type: types.CLEAR_LOGIN_STATUS
  };
}

function getUserPrivileges() {
  const token = localStorage.getItem('token');
  return () => getAxios().post('/userPrivileges', { token }).then((response) => response.data);
}
function checkUserPrivileges() {
  const aciton = {
    type: 'API',
    types: [types.USER_PRIVILEGES, types.USER_PRIVILEGES_FULFILLED, types.USER_PRIVILEGES_REJECTED],
    api: getUserPrivileges()
  };
  return aciton;
}

function fetchExternalSignInParameters() {
  const action = {
    type: 'API',
    types: [types.GET_EXTERNAL_SIGNIN_PARAMS, types.GET_EXTERNAL_SIGNIN_PARAMS_FULFILLED, types.GET_EXTERNAL_SIGNIN_PARAMS_REJECTED],
    api: () => getAxios().get('/externalSignInOptions').then((response) => response.data)
  };
  return action;
}

function doClockIn() {
  const token = localStorage.getItem('token');
  const data = {
    token,
    signOnOff: 'ON',
    signOnType: 'ATTENDANCE',
    laborSignOnType: 'y',
    signOffAll: 'y'
  };

  return () => getAxios().post('/clockInOut', data).then((response) => response);
}

function clockIn() {
  const action = {
    type: 'API',
    types: [types.CLOCK_IN, types.CLOCK_IN_FULFILLED, types.CLOCK_IN_REJECTED],
    api: doClockIn()
  };
  return action;
}

const actions = {
  postLogin,
  clearLoginStatus,
  checkUserPrivileges,
  fetchExternalSignInParameters,
  clockIn
};

export {
  types,
  actions
};